import AuthService from 'lib/auth/AuthService';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTeamAccounts, selectAccountById } from 'store/accounts';
import { getIntegrations } from 'store/integrations';
import { getAccountTeams } from 'store/teams';
import { getTeamUserGroups } from 'store/userGroups';
import { loadAuth } from 'store/v1/auth/auth.actions.js';
import { AUTH_ACTIONS } from 'store/v1/auth/auth.constants.js';
import useEvent from 'v1/helpers/hooks/useEvent';

export function useAuthSync() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = AuthService.token();
    dispatch(loadAuth(token, token.tokenString, ''));
    setIsLoading(true);
  }, [dispatch]);

  useEvent([AUTH_ACTIONS.LOAD_AUTH], {
    onSuccess: () => {
      setIsLoading(false);
      dispatch(getAccountTeams());
      dispatch(getTeamAccounts());
      dispatch(getTeamUserGroups());
      dispatch(getIntegrations());
    }
  });

  const token = AuthService.token();
  const id = token.account.id;
  const account = useSelector((state: any) => selectAccountById(state, id));

  return { account, isLoading };
}
